import { render, staticRenderFns } from "./FeatureComparisonTable.vue?vue&type=template&id=6e94bc45&scoped=true"
import script from "./FeatureComparisonTable.vue?vue&type=script&lang=js"
export * from "./FeatureComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./FeatureComparisonTable.vue?vue&type=style&index=0&id=6e94bc45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e94bc45",
  null
  
)

export default component.exports